import { Fragment } from 'react'
import AppStyleDecider from '../../../../baseComponents/AppsStyleDecider'
import NullComponent from '../../../../baseComponents/NullComponent'
import InputTableLayout, { BigTitleAndRightLayoutInputTableNewCustomer, InputTableLayoutNew, InputTableLayoutProps } from '../../../../baseComponents/TwinTable/InputTableLayout'
import { ITBooleanRender, ITDeleteRowBuy, ITDisplayEditFinalPrice, ITDisplayEditFinalPriceBase, ITDisplayFinalPrice, ITDisplayImage, ITDisplayPrice, ITDisplayPriceNotRounded } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITInputSelect, ITInputSelectAccounts, ITInputSelectWarehouses } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Inputs'
import { InputTableFooterFullProps } from '../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { DictionaryComponents } from '../../../../utils/globals/types'
import useOrderCalculateTotals from '../../../../utils/hooks/orders/useOrderCalculateTotals'
import { BuySelectedCheckbox } from '../../../buys/components'
import ModalsOrderBuyLayout from '../OrderBuyLayout/ModalsOrderBuyLayout'
import { ITOrderBooleanRectangle, OrderCustomSelectBlockedItemsSearchbar, OrderEditableName, OrderEditableText, OrderInputCalendar, OrderInputDiscount, OrderInputPercentage, OrderInputPrice, OrderInputQuantity, OrderInputQuantity2, OrderRectangularInputSmall, OrderSaveRemainingProduct } from '../OrderLayout/OrderTable/TableComponents/Inputs'
import OrderSearchProductInput, { OrderSearchProductInputCreate, OrderSearchProductInputName, OrderSearchProductInputReferenceAndName } from '../OrderLayout/OrderTable/TableComponents/Inputs/OrderSearchProductInput'
import OrderEditBuyAddonProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditBuyAddonProduct'
import OrderEditProduct from '../OrderLayout/OrderTable/TableComponents/OrderEditProduct'
import OrderPrintTags from '../OrderLayout/OrderTable/TableComponents/OrderPrintTags'
import OrderUniqueNumberProduct, { OrderUniqueNumberProductReadOnly } from '../OrderLayout/OrderTable/TableComponents/OrderUniqueNumberProduct'
import { OrderDragHandle } from '../OrderLayout/OrderTable/TableComponents/Sorts'
import { useOrderLayoutTableLogic } from '../OrderLayout/OrderTable/useOrderLayoutTableLogic'
import OrderTotal, { OrderTotalNew } from '../OrderLayout/OrderTotal'

interface OrderAdjustmentDeliveryNoteLayoutProps extends InputTableLayoutProps {
    orderStatusDict: TwinDictionary
}

const OrderAdjustmentDeliveryNoteLayout: React.FC<OrderAdjustmentDeliveryNoteLayoutProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={InputTableLayoutRenderDefault} NewComponent={InputTableLayoutRenderNew} {...rest} />
    )
}

const InputTableLayoutRenderDefault: React.FC<OrderAdjustmentDeliveryNoteLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayout hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildren} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const InputTableLayoutRenderNew: React.FC<OrderAdjustmentDeliveryNoteLayoutProps> = ({ ...rest }) => {
    return (
        <InputTableLayoutNew hookFunction={useOrderLayoutTableLogic} TableChildren={OrderTableChildrenNew} {...rest} components={components} BigAndTitleRightLayout={BigTitleAndRightLayoutInputTableNewCustomer} />
    )
}

const OrderTableChildren: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotal costs={{}} {...{ completeData, CurrencyId, skipEdit: true, totalsOrderTableData, ...rest }} /> : null}
            <ModalsOrderBuyLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} />
        </Fragment>
    )
}

const OrderTableChildrenNew: React.FC<InputTableFooterFullProps> = ({ completeData, CurrencyId, eventFunctions, customParseTableData, ...rest }) => {
    const { totalsOrderTableData } = useOrderCalculateTotals({ completeData, customParseTableData })
    return (
        <Fragment>
            {!completeData?.header?.hidePrices ? <OrderTotalNew costs={{}} FooterOrderRowShortComponent={NullComponent} FooterOrderLeftConfigComponent={NullComponent} {...{ completeData, CurrencyId, skipEdit: true, totalsOrderTableData, ...rest, isReadOnly: true}} /> : null}
            <ModalsOrderBuyLayout headerData={completeData.header} deleteLine={eventFunctions.deleteLine} onChangeAdd={eventFunctions.onChangeAdd} onChangeFetch={eventFunctions.onChangeFetch} onChangeUpdate={eventFunctions.onChangeUpdate} completeData={completeData} {...rest} />
        </Fragment>
    )
}

const components: DictionaryComponents = {
    ITRectangularInput: OrderRectangularInputSmall,
    ITEditableText: OrderEditableText,
    ITEditableName: OrderEditableName,
    ITInputNumeric: OrderInputPrice,
    ITInputPercentage: OrderInputPercentage,
    OrderSearchProductInput: OrderSearchProductInput,
    OrderSearchProductInputName: OrderSearchProductInputName,
    OrderSearchProductInputReferenceAndName: OrderSearchProductInputReferenceAndName,
    OrderSearchProductInputCreate: OrderSearchProductInputCreate,
    OrderSaveRemainingProduct: OrderSaveRemainingProduct,
    ITOrderBooleanRectangle: ITOrderBooleanRectangle,
    OrderUniqueNumberProduct: OrderUniqueNumberProduct,
    OrderUniqueNumberProductReadOnly: OrderUniqueNumberProductReadOnly,
    ITSelectSpecificPriceRule: OrderCustomSelectBlockedItemsSearchbar,
    ITInputQuantity: OrderInputQuantity,
    ITInputQuantity2: OrderInputQuantity2,
    ITInputDiscount: OrderInputDiscount,
    ITInputCalendar: OrderInputCalendar,
    ITDragHandle: OrderDragHandle,
    ITDisplayPrice: ITDisplayPrice,
    ITInputPrice: OrderInputPrice,
    ITDisplayPriceNotRounded: ITDisplayPriceNotRounded,
    ITDisplayFinalPrice: ITDisplayFinalPrice,
    ITDisplayEditFinalPrice: ITDisplayEditFinalPrice,
    ITDisplayEditFinalPriceBase: ITDisplayEditFinalPriceBase,
    OrderEditProduct: OrderEditProduct,
    OrderEditAddonProduct: OrderEditBuyAddonProduct,
    OrderPrintTags,
    ITDisplayImage: ITDisplayImage,
    ITBooleanRender: ITBooleanRender,
    ITInputSelectAccounts: ITInputSelectAccounts,
    ITInputSelect: ITInputSelect,
    CheckboxComponent: BuySelectedCheckbox,
    DeleteComponent: ITDeleteRowBuy,
    ITInputSelectWarehouses
}


export default OrderAdjustmentDeliveryNoteLayout